module.exports = "https://static.energy5.com/_next/static/images/glance-4-722dfc9561e4d03031cb0ea94b717f7a.png";